import React, { useContext, useEffect, useState } from "react";
import Logo from "./Logo";
import "./Header.scss";
import RulesIcon from '../../assets/img/icons/updated-file.svg';


const Header = ({ className = "" }) => {


  return (
    <>
      <div className={`header d-flex align-items-center justify-content-between ${className}`}>
        <Logo />
        <div className="flex-grow-1 d-flex justify-content-center">
          <h1>
            MORi DocAssist
          </h1>
        </div>
        <div className="right-col ms-auto d-flex align-items-center flex-shrink-0">
        <img src={RulesIcon} alt="Rules Icon" style={{ width: '50px', height: '50px' }} />
        </div>
      </div>
    </>
  );
};
export default Header;